import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPropertyDamaged = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 42,
	height: 42,
	viewBox: "0 0 42 42",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	stroke: "#0DC277",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10.9805 22.0002H14.7705C15.5305 22.0002 16.2205 22.4302 16.5605 23.1102L17.4505 24.9002C18.0005 26.0002 19.0005 26.0002 19.2405 26.0002H22.7705C23.5305 26.0002 24.2205 25.5702 24.5605 24.8902L25.4505 23.1002C25.7905 22.4202 26.4805 21.9902 27.2405 21.9902H30.9805",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28 18C30.2091 18 32 16.2091 32 14C32 11.7909 30.2091 10 28 10C25.7909 10 24 11.7909 24 14C24 16.2091 25.7909 18 28 18Z",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26 14.4924L27.2692 16L30 13",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23 11H18C13 11 11 13 11 18V24C11 29 13 31 18 31H24C29 31 31 29 31 24V19",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.8281 20H22.1581",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18 17H23",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgPropertyDamaged;
